@if (showSplash()) {
  <app-overlay-splash variant="entry" />
} @else {
  <ion-app>
    <ion-router-outlet></ion-router-outlet>
  </ion-app>
}
